const PUBLIC_ROUTE_PREFIX = 'public';

export function isPublicContentfulRoute(route) {
  const normalizedRoute = String(route || '').trim().toLowerCase();
  return normalizedRoute === PUBLIC_ROUTE_PREFIX || normalizedRoute.indexOf(`${PUBLIC_ROUTE_PREFIX}/`) === 0;
}

export function filterPublicGenericPageWithNews(queryData) {
  if (!queryData || !Array.isArray(queryData.genericPageWithNews)) {
    return queryData;
  }

  const genericPageWithNews = queryData.genericPageWithNews.filter((page) => {
    return !isPublicContentfulRoute(page && page.route);
  });

  if (genericPageWithNews.length === queryData.genericPageWithNews.length) {
    return queryData;
  }

  return {
    ...queryData,
    genericPageWithNews,
  };
}
